//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../Join/Join.PointLayoutPointBuilderList.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[0,"DistanceFromEnds",1,0],[0,"DistanceTolerance",1,0],[1,"EndDistance",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"GuidePath",0,"Section",0],[0,"MaximumSpacingBetweenPoints",1,0],[0,"MinimumNumberPoints",1,0],[0,"MinimumSpacingBetweenPoints",1,0],[1,"NumberOfPoints",0,"Expression",0],[1,"PointList",0,"Join.PointLayoutPointBuilderList",0],[1,"Spacing",0,"Expression",0],[0,"SpacingMethod",1,0],[0,"SpacingOption",1,0],[1,"StartDistance",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"Type",1,0],[0,"UniformSpacingTolerance",1,0]],[[[],"NewPoints",{R_:{newPointBuilder:"Join.PointLayoutPointBuilder"}},0,0],[[],"AppendPoints",{},0,0]],[]];
SPLM.Join.PointLayoutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.PointLayoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.PointLayoutBuilder.SpacingTypes = Object.freeze({
    "Manual" : "Manual", "Automatic" : "Automatic"});

SPLM.Join.PointLayoutBuilder.SpaceMethod = Object.freeze({
    "ArcLength" : "ArcLength", "ParallelXPlane" : "ParallelXPlane", "ParallelYPlane" : "ParallelYPlane", "ParallelZPlane" : "ParallelZPlane"});

SPLM.Join.PointLayoutBuilder.SpaceOption = Object.freeze({
    "Distance" : "Distance", "Number" : "Number", "MinimumDistance" : "MinimumDistance"});

export default SPLM;